module.exports = function() {
  return new Worker(__webpack_public_path__ + "7fd24c122cd492d9a3a5.worker.js");
};